import { useContext } from 'react'

import { ModalContext, ModalContextProps } from '@/contexts/modal'

interface UseModalProps {
  modal: ModalContextProps['modal']
  open: ModalContextProps['openModal']
  close: ModalContextProps['closeModal']
}

export const useModal = (): UseModalProps => {
  const { modal, openModal: open, closeModal: close } = useContext(ModalContext)

  return {
    modal,
    open,
    close
  }
}
